import SortIndicators from './SortIndicators';

export default SortIndicators;
